import { useContext } from 'react';
import { isConfigReport, isJourneyReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { showDatawellInsight } from '../../SRVDatawellInsight';
import ConfigReportKPIContent from './ConfigReportKPIContent';
import JourneyReportKPIContent from './journey-report-kpis/JourneyReportKPIContent';
import RelationalReportKPIContent from './relational-report-kpis/RelationalReportKPIContent';
import SalesCustomWidgetKPIContent, { hasCustomWidgetKpis } from './sales-custom-widget-kpis/SalesCustomWidgetKPIContent';
import { jsx as _jsx } from "react/jsx-runtime";
const ReportKPIContent = ({
  appUsageTracker,
  previewReport,
  reportResolve
}) => {
  const userInfo = useContext(UserInfoContext);
  const gates = userInfo === null || userInfo === void 0 ? void 0 : userInfo.gates;
  if (!showDatawellInsight(previewReport)) {
    return null;
  }
  if (isConfigReport(previewReport)) {
    if (hasCustomWidgetKpis(previewReport)) {
      return /*#__PURE__*/_jsx("div", {
        "data-test-id": "custom-widget-kpi-content",
        children: /*#__PURE__*/_jsx(SalesCustomWidgetKPIContent, {
          previewReport: previewReport,
          reportResolve: reportResolve
        })
      });
    }
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "config-report-kpi-content",
      children: /*#__PURE__*/_jsx(ConfigReportKPIContent, {
        appUsageTracker: appUsageTracker,
        previewReport: previewReport,
        gates: gates
      })
    });
  } else if (isRelationalReport(previewReport)) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "relational-report-kpi-content",
      children: /*#__PURE__*/_jsx(RelationalReportKPIContent, {
        appUsageTracker: appUsageTracker,
        previewReport: previewReport
      })
    });
  } else if (isJourneyReport(previewReport)) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "journey-report-kpi-content",
      children: /*#__PURE__*/_jsx(JourneyReportKPIContent, {
        previewReport: previewReport,
        reportResolve: reportResolve
      })
    });
  }
  return null;
};
export default ReportKPIContent;